"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var yup = _interopRequireWildcard(require("yup"));

var _get = _interopRequireDefault(require("lodash/get"));

var _head = _interopRequireDefault(require("lodash/head"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var pdfjs = _interopRequireWildcard(require("pdfjs-dist"));

var _pdf_viewer = require("pdfjs-dist/web/pdf_viewer");

var _pdf_thumbnail_viewer = require("pdfjs-dist/lib/web/pdf_thumbnail_viewer");

var _pdf_rendering_queue = require("pdfjs-dist/lib/web/pdf_rendering_queue");

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

var _NotAvailable = _interopRequireDefault(require("./NotAvailable"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _Input = _interopRequireDefault(require("../Input"));

var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Button = _interopRequireDefault(require("../Button"));

require("./PDF.css");

// $FlowFixMe
pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.4.456/pdf.worker.js';
var ZOOM_STEP = 0.25;
var DEFAULT_ZOOM = 0.9;
var PORTRAIT_VIEWPORT_RATIO = 0.9;
var LANDSCAPE_VIEWPORT_RATIO = 0.66;
var MAX_WIDTH = 800;
var N0_PASSWORD_GIVEN = 1;
var INVALID_PASSWORD = 2;

var PDFPreview = function PDFPreview(_ref) {
  var src = _ref.src,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      doc = _useState6[0],
      setDoc = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      password = _useState8[0],
      setPassword = _useState8[1];

  var viewer = (0, _react.useRef)(null);
  var eventBus = (0, _react.useRef)(null);
  var linkService = (0, _react.useRef)(null);
  var findController = (0, _react.useRef)(null);
  var renderingQueue = (0, _react.useRef)(null);
  var thumbnailViewer = (0, _react.useRef)(null); // Zoom state values

  var initialZoomLevelRef = (0, _react.useRef)(DEFAULT_ZOOM);

  var _useState9 = (0, _react.useState)(DEFAULT_ZOOM),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      zoomLevel = _useState10[0],
      setZoomLevel = _useState10[1];

  var incrementZoomLevel = function incrementZoomLevel() {
    return setZoomLevel(function (level) {
      return level + ZOOM_STEP;
    });
  };

  var decrementZoomLevel = function decrementZoomLevel() {
    return setZoomLevel(function (level) {
      return level - ZOOM_STEP;
    });
  };

  var resetZoomLevel = function resetZoomLevel() {
    return setZoomLevel(initialZoomLevelRef.current);
  }; // Thumbnails


  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      showThumbnails = _useState12[0],
      setThumbnails = _useState12[1];

  var toggleThumbnails = function toggleThumbnails() {
    return setThumbnails(function (state) {
      return !state;
    });
  };

  (0, _react.useEffect)(function () {
    // Set PDF.js scale level
    if (viewer.current) {
      // Default should be 90%, assume portrait for now, we will handle
      // landscape in a different improvement.
      viewer.current.currentScaleValue = zoomLevel; // Render visible pages

      viewer.current.update();
    }
  }, [zoomLevel]);
  (0, _react.useEffect)(function () {
    setLoading(true);
    var loadingTask = password ? pdfjs.getDocument({
      url: src,
      password: password
    }) : pdfjs.getDocument(src);
    loadingTask.promise.then(function (doc) {
      setDoc(doc);
      setLoading(false);
      setError(null);
    })["catch"](function (err) {
      // Password exception
      if (err.code === N0_PASSWORD_GIVEN) {
        setPassword(null);
      }

      setError(err);
      setLoading(false);
    });
  }, [src, password]);
  (0, _react.useEffect)(function () {
    var container = document.getElementById('viewerContainer');
    eventBus.current = new _pdf_viewer.EventBus();
    linkService.current = new _pdf_viewer.PDFLinkService({
      eventBus: eventBus.current
    });
    findController.current = new _pdf_viewer.PDFFindController({
      eventBus: eventBus.current,
      linkService: linkService.current
    });
    renderingQueue.current = new _pdf_rendering_queue.PDFRenderingQueue();
    viewer.current = new _pdf_viewer.PDFViewer({
      container: container,
      eventBus: eventBus.current,
      linkService: linkService.current,
      findController: findController.current,
      renderingQueue: renderingQueue.current
    });

    if (linkService.current) {
      linkService.current.setViewer(viewer.current);
    }

    if (renderingQueue.current && viewer.current) {
      renderingQueue.current.setViewer(viewer.current);
    }

    if (eventBus.current) {
      eventBus.current.on('pagesinit', function () {
        if (viewer.current) {
          var initialScale = getInitialScale(viewer.current);
          var scale = Math.round((initialScale + Number.EPSILON) * 100) / 100;
          initialZoomLevelRef.current = scale;
          setZoomLevel(scale);
        }
      });
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (viewer.current) {
      viewer.current.setDocument(doc);
    }

    if (linkService.current) {
      linkService.current.setDocument(doc, null);
    }
  }, [doc]); // Show thumbnails when we display the pane

  (0, _react.useEffect)(function () {
    if (renderingQueue.current) {
      renderingQueue.current.isThumbnailViewEnabled = showThumbnails;
    }

    if (!showThumbnails) {
      return;
    }

    var thumbnailsContainer = document.getElementById('thumbnailsContainer');
    thumbnailViewer.current = new _pdf_thumbnail_viewer.PDFThumbnailViewer({
      container: thumbnailsContainer,
      eventBus: eventBus.current,
      linkService: linkService.current,
      renderingQueue: renderingQueue.current
    });

    if (thumbnailViewer.current) {
      if (doc) {
        thumbnailViewer.current.setDocument(doc);
      }

      if (renderingQueue.current) {
        renderingQueue.current.setThumbnailViewer(thumbnailViewer.current);
      }
    } // TODO: This is a really hacky workaround for rendering the thumbnails
    // successfully. Simply calling:
    //
    // thumbnailViewer.current.forceRendering()
    //
    // does nothing...


    var rendered = thumbnailViewer.current.forceRendering();
    var retry = setInterval(function () {
      if (rendered) {
        clearInterval(retry);
      }

      if (!rendered) {
        rendered = thumbnailViewer.current.forceRendering();
      }
    }, 300);
  }, [showThumbnails]); // Click events

  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(e) {
      if (e.target.id === 'viewerContainer') {
        // Close if we are clicking on the exterior of the PDF preview
        onClose();
      }
    };

    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  var missingPassword = error && error.code === N0_PASSWORD_GIVEN;
  var invalidPassword = error && error.code === INVALID_PASSWORD;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "viewerContainer",
    className: "h-full w-full relative flex justify-center overflow-auto mt-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "viewer",
    className: (0, _classnames["default"])('pdfViewer', {
      'opacity-0': isLoading
    })
  }), showThumbnails && /*#__PURE__*/_react["default"].createElement("div", {
    id: "thumbnailsContainer"
  }), !error && !isLoading && /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
    disabledZoomReset: equalZoomLevel(initialZoomLevelRef.current, zoomLevel),
    disabledZoomOut: Math.round(zoomLevel * 100) <= Math.round(initialZoomLevelRef.current * 100),
    showThumbnails: showThumbnails,
    onToggleThumbnails: toggleThumbnails,
    onZoomIn: incrementZoomLevel,
    onZoomOut: decrementZoomLevel,
    onZoomReset: resetZoomLevel
  }), isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute inset-0"
  }, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    fullWidth: true,
    fullHeight: true
  })), !!error && !missingPassword && !invalidPassword && /*#__PURE__*/_react["default"].createElement(_NotAvailable["default"], {
    onClose: onClose
  }), (missingPassword || invalidPassword) && /*#__PURE__*/_react["default"].createElement(Password, {
    onConfirm: function onConfirm(_ref2) {
      var password = _ref2.password;
      setLoading(true);
      var loadingTask = pdfjs.getDocument({
        url: src,
        password: password
      });
      return new Promise(function (resolve, reject) {
        loadingTask.promise.then(function (doc) {
          setDoc(doc);
          setLoading(false);
          setError(null);
        })["catch"](reject);
      })["catch"](function (err) {
        setError(err);
        setLoading(false);
        return Promise.reject(err);
      });
    }
  }));
};

var Password = function Password(_ref3) {
  var onConfirm = _ref3.onConfirm;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var formikRef = (0, _react.useRef)(null);

  function handleSubmit(values) {
    Promise.resolve(onConfirm(values))["catch"](function (err) {
      if (formikRef && formikRef.current) {
        formikRef.current.setFieldError('password', t('incorrectPassword'));
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "container max-w-sm"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    ref: formikRef,
    initialValues: {
      password: ''
    },
    validationSchema: yup.object().shape({
      password: yup.string().required()
    }),
    onSubmit: handleSubmit
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        errors = _ref4.errors;
    var isInvalidPassword = (errors === null || errors === void 0 ? void 0 : errors.password) === t('incorrectPassword');
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "mt-24 bg-card shadow-lg p-12"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "text-dark font-bold text-2xl mb-5"
    }, t('preview.passwordProtected')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-8"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('preview.passwordProtected.label')), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      autoFocus: true,
      className: "w-full",
      name: "password",
      type: "password"
    }), isInvalidPassword && /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "password"
    })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "submit",
      disabled: !isValid,
      className: "w-full"
    }, t('button.confirm')));
  }));
}; // Returns the initial scale for the preview


var getInitialScale = function getInitialScale(viewer) {
  if ((0, _isNil["default"])(viewer)) {
    return DEFAULT_ZOOM;
  } // Get the first page's height


  var firstPage = (0, _head["default"])(viewer._pages);

  if ((0, _isNil["default"])(firstPage)) {
    // Something's wrong here, first page should exist
    return DEFAULT_ZOOM;
  }

  var viewerHeight = (0, _get["default"])(viewer, 'viewer.clientHeight');
  var height = (0, _get["default"])(firstPage, 'viewport.height');
  var width = (0, _get["default"])(firstPage, 'viewport.width');

  if ([viewerHeight, height, width].some(function (item) {
    return !item;
  })) {
    // If item is null/undefined/0, return the default zoom, something's not
    // right here
    return DEFAULT_ZOOM;
  }

  var isLandscape = height <= width;
  var heightRatio = isLandscape ? LANDSCAPE_VIEWPORT_RATIO : PORTRAIT_VIEWPORT_RATIO;
  var targetHeight = viewerHeight * heightRatio;
  var scale = targetHeight / height; // If after scaling, width exceeds MAX_WIDTH, scale the image according to
  // max width instead

  if (width * scale >= MAX_WIDTH) {
    return MAX_WIDTH / width;
  }

  return scale;
};

var equalZoomLevel = function equalZoomLevel(foo, bar) {
  return Math.round(foo * 100) === Math.round(bar * 100);
};

var _default = PDFPreview;
exports["default"] = _default;
//# sourceMappingURL=PDF.js.map